import axios from 'axios';
import axiosRetry from 'axios-retry';
import toastr from 'toastr';
import * as actions from './actionsTypes';
import errorManage from '../../errorManage';
import messages from '../../messages';

const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const getSegment = data => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_SEGMENT,
      payload: true
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.get(`/api/app/Clima_Segmento/`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      },
      params: data
    });
    dispatch({
      type: actions.GET_SEGMENT,
      payload: {
        segment: resp.data.data,
        segmentLength: resp.data.count
      }
    });
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_SEGMENT,
      payload: false
    });
  }
}

export const getEmployees = params => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_SEGMENT_EMPLOYEES,
      payload: true
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.get(`/api/app/funcional_empleado_activos_lista_sencilla_dias_habiles/`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      },
      params: params
    });
    dispatch({
      type: actions.GET_SEGMENT_EMPLOYEES,
      payload: resp.data.data
    });
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_SEGMENT_EMPLOYEES,
      payload: false
    });
  }
}

export const saveSegment = (data, maintenance, setShowFormModal, history) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_SEGMENT,
      payload: true
    });

    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.post('/api/app/Clima_Segmento/', data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }});
    const { segment, segmentLength } = getState().segment;
    const aSegment = [...segment, resp.data];
    dispatch({
      type: actions.GET_SEGMENT,
      payload: {
        segment: aSegment,
        segmentLength: segmentLength + 1
      }
    });
    setShowFormModal(false);
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    if (!maintenance) {
      history.push(`/segmentación`);
    }
    dispatch({
      type: actions.SAVE_LOADER_SEGMENT,
      payload: false
    });
  }
}

export const editSegment = (data, id, index, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_SEGMENT,
      payload: true
    });

    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.put(`/api/app/Clima_Segmento/${id}/`, data, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    }});
    const { segment, segmentLength } = getState().segment;
    segment[index] = resp.data;
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_SEGMENT,
      payload: {
        segment: segment,
        segmentLength: segmentLength
      }
    });
    dispatch({
      type: actions.FORM_SEGMENT_FAIL,
      payload: "",
  });
  setShowModal(false)
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_SEGMENT,
      payload: false
    });
  }
}

export const deleteSegment = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_SEGMENT,
      payload: true
    });
    
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    await client.delete(`/api/app/Clima_Segmento/${id}/`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    }});
    const { segment, segmentLength } = getState().segment;
    segment.splice(index, 1);
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_SEGMENT,
      payload: {
        segment: segment,
        segmentLength: segmentLength -1
      }
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_SEGMENT,
      payload: false
    });
  }
}

export const getClimaPuesto = data => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_CLIMA_Funcional_PuestoXUnidad_Organizativa,
      payload: true
    });
    const dataT = {"unidad_organizativa_id":[]}
    data.forEach(item => {
      dataT.unidad_organizativa_id = [...dataT.unidad_organizativa_id, item.value ? item.value : item.id]
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.post('/api/app/Clima_Funcional_PuestoXUnidad_Organizativa/',dataT, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }});
    var puestos = resp.data.data;
    var puestosT = [];
    puestos.forEach(item=>{
      puestosT=[...puestosT,{value:item.id,label:item.codigo+' / '+item.descripcion_larga}]
    })
    dispatch({
      type: actions.GET_CLIMA_Funcional_PuestoXUnidad_Organizativa,
      payload: {
        puesto: puestosT,
        puestoLength: resp.data.count
      }
    });
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_CLIMA_Funcional_PuestoXUnidad_Organizativa,
      payload: false
    });
  }
}

export const getClimaOrganizacion = data => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_CLIMA_Funcional_Unidad_OrganizativaXOrganizacion,
      payload: true
    });
    const dataT = {"organizacion_id":[]}
    data.forEach(item => {
      dataT.organizacion_id = [...dataT.organizacion_id,item.value ? item.value : item.id]
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.post('/api/app/Clima_Funcional_Unidad_OrganizativaXOrganizacion/',dataT, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }});
    var unidades = resp.data.data;
    var unidadesT = [];
    unidades.forEach(item=>{
      unidadesT=[...unidadesT,{value:item.id,label:item.codigo+' / '+item.nombre}]
    })
    dispatch({
      type: actions.GET_CLIMA_Funcional_Unidad_OrganizativaXOrganizacion,
      payload: {
        unidad: unidadesT,
        unidadLength: resp.data.count
      }
    });
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_CLIMA_Funcional_Unidad_OrganizativaXOrganizacion,
      payload: false
    });
  }
}